import { useState } from 'react';
import { Card } from '../../new-components/ui/card';
import { Button } from '../../new-components/ui/button';
import TwoFactorSetupModal from '../../TwoFactorSetupModal';
import { useUser } from '../../../contexts/UserContext';
import { toast } from 'react-hot-toast';
import { SETTINGS_PANEL } from '../ui';

/**
 * Security Settings — self-contained Settings section. Owns the 2FA modal state and the modal
 * itself. The section title lives on the SettingsDetail page (<h1>), so this card only carries
 * the action rows.
 */
export function SecuritySection() {
  const { user, refreshUser } = useUser();
  const [show2FAModal, setShow2FAModal] = useState(false);

  const rowClass = 'flex flex-col gap-3 px-4 py-4 sm:flex-row sm:items-center sm:justify-between';

  return (
    <>
      <Card className="p-6 border-border">
        <div className={`${SETTINGS_PANEL} divide-y divide-border`}>
          {/* Password */}
          <div className={rowClass}>
            <div className="min-w-0">
              <p className="text-sm font-medium text-foreground">Password</p>
              <p className="mt-0.5 text-sm text-muted-foreground">
                Update your password regularly to keep your account secure
              </p>
            </div>
            <Button variant="outline" className="self-start sm:self-auto">
              Change Password
            </Button>
          </div>

          {/* Two-Factor Authentication */}
          <div className={rowClass}>
            <div className="min-w-0">
              <p className="text-sm font-medium text-foreground">Two-Factor Authentication</p>
              <p className="mt-0.5 text-sm text-muted-foreground">
                Add an extra layer of security to your account
              </p>
            </div>
            <Button variant="outline" onClick={() => setShow2FAModal(true)} className="self-start sm:self-auto">
              {user?.two_factor_enabled ? 'Manage 2FA' : 'Enable 2FA'}
            </Button>
          </div>

          {/* Active Sessions */}
          <div className="flex flex-col gap-3 px-4 py-4 sm:flex-row sm:items-start sm:justify-between">
            <div className="min-w-0">
              <p className="text-sm font-medium text-foreground">Active Sessions</p>
              <p className="mt-0.5 text-sm text-muted-foreground">
                Manage your active sessions and log out from other devices
              </p>
            </div>
            <div className="sm:text-right">
              <p className="flex items-center gap-2 text-sm font-medium text-foreground sm:justify-end">
                Current session
                <span className="inline-flex items-center gap-1 text-xs font-medium text-[hsl(var(--success))]">
                  <span className="h-1.5 w-1.5 rounded-full bg-[hsl(var(--success))]" aria-hidden="true" />
                  Active
                </span>
              </p>
              <p className="mt-0.5 text-xs text-muted-foreground">{new Date().toLocaleString()}</p>
            </div>
          </div>
        </div>
      </Card>

      {/* 2FA Setup Modal */}
      <TwoFactorSetupModal
        isOpen={show2FAModal}
        onClose={() => setShow2FAModal(false)}
        onSuccess={() => {
          refreshUser();
          toast.success('Two-factor authentication enabled!');
        }}
      />
    </>
  );
}

export default SecuritySection;
